import CityPageTemplate from "../city-template/CityPageTemplate";
import { oaklandConfig } from "./data";

export default function OaklandPage() {
  return <CityPageTemplate config={oaklandConfig} />;
}